import { Vue, Component, Watch, Prop } from 'vue-property-decorator'
import { ApiException } from '@/services/connecteur'
import { ToastOptions } from 'vue-toasted'

@Component
export default class InputWithValidation extends Vue {
  @Prop({ default: '' })
  public rules!: object | string

  @Prop({ default: false })
  public immediate!: boolean

  @Prop()
  public value!: any

  public innerValue: any = ''

  created() {
    if (this.value) {
      this.innerValue = this.value
    }
  }

  @Watch('innerValue')
  protected innerValueUpdated(newVal: string) {
    this.$emit('input', newVal)
  }

  @Watch('value')
  protected valueUpdated(newVal: string) {
    this.innerValue = newVal
  }
}
